import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import React, {useContext, useEffect} from 'react'
import {useConfig} from './ConfigProvider'
import {OrderProvider} from './OrderProvider'

type Props = {
  children: React.ReactNode
}

export const FingerprintContext = React.createContext<null>(null)

export const FingerprintProvider = ({children}: Props) => {
  const order = OrderProvider.useOrder('optional')
  const {fingerprintPublicKey} = useConfig()

  useEffect(() => {
    if (!order) {
      return
    }

    ;(async function fingerprint() {
      const fp = await FingerprintJS.load({
        apiKey: fingerprintPublicKey,
        endpoint: 'https://fp.ventrata.com',
        scriptUrlPattern: 'https://fp.ventrata.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
      })

      fp.get({linkedId: order.fingerprintLinkedId})
    })()
  }, [order, fingerprintPublicKey])

  return <FingerprintContext.Provider value={null}>{children}</FingerprintContext.Provider>
}

export const useFpPromise = () => {
  const fpPromise = useContext(FingerprintContext)

  if (!fpPromise) {
    throw new Error('fpPromise is null')
  }

  return fpPromise
}
